<template>
    <card :title="dispenseErrorLabel + 's'">
        <DispenseErrorListComponent :mode="mode" />
    </card>
</template>

<script lang="ts">
import Card from '@/components/Cards/Card.vue';
import { Component, Vue } from 'vue-property-decorator';
import DispenseErrorListComponent from '@/components/DispensingError/DispenseErrorListComponent.vue'

@Component({
    name: "ReportedErrorsPage",
    components: {
        DispenseErrorListComponent
    }
})
export default class ReportedErrorsPage extends Vue {

    mounted() {
        this.fetchDispenseErrorLabel();
    }

    get mode() {
        if (this.onlyAssignedErrors) return "assigned";
        return "default";
    }

    get onlyAssignedErrors(): boolean {
        return Boolean(this.$route.params.onlyAssigned);
    }

    protected dispenseErrorLabel = "";

    async fetchDispenseErrorLabel() {
        try {
            const resp = await this.$http.get("/Configuration/DispenseErrorLabel");
            this.dispenseErrorLabel = resp.data?.trim();
        } catch {
            this.dispenseErrorLabel = "Error";
            //ignore
        }
    }

}
</script>
